'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _audioplayer = require('redux/modules/audioplayer');

var audioplayerActions = _interopRequireWildcard(_audioplayer);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _AudioPlayer = require('helpers/AudioPlayer');

var _AudioPlayer2 = _interopRequireDefault(_AudioPlayer);

var _MyPlaylistsAddIcon = require('components/MyPlaylistsAddIcon/MyPlaylistsAddIcon');

var _MyPlaylistsAddIcon2 = _interopRequireDefault(_MyPlaylistsAddIcon);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./QuickSendTracklist.scss');

var QuickSendTracklist = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    currentTrackIndex: state.audioplayer.currentTrackIndex,
    humanizedPosition: state.audioplayer.humanizedPosition,
    playerStatus: state.audioplayer.playerStatus,
    playerTracks: state.audioplayer.tracks
  };
}, (0, _extends3.default)({}, audioplayerActions)), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(QuickSendTracklist, _Component);

  function QuickSendTracklist() {
    (0, _classCallCheck3.default)(this, QuickSendTracklist);
    return (0, _possibleConstructorReturn3.default)(this, (QuickSendTracklist.__proto__ || (0, _getPrototypeOf2.default)(QuickSendTracklist)).apply(this, arguments));
  }

  (0, _createClass3.default)(QuickSendTracklist, [{
    key: 'play',
    value: function play(index) {
      var _props = this.props,
          playAlbum = _props.playAlbum,
          album = _props.album,
          tracks = _props.tracks;

      playAlbum({ album: album, tracks: tracks, currentTrackIndex: index });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          tracks = _props2.tracks,
          playerTracks = _props2.playerTracks,
          currentTrackIndex = _props2.currentTrackIndex,
          playerStatus = _props2.playerStatus,
          humanizedPosition = _props2.humanizedPosition,
          playable = _props2.playable,
          className = _props2.className;

      var currentTrack = playerTracks[currentTrackIndex] || {};
      var isPlayState = function isPlayState(id) {
        return currentTrack.id === id && playerStatus === _AudioPlayer2.default.status.play;
      };
      var getPlayPauseClass = function getPlayPauseClass(id) {
        return (0, _classnames2.default)(styles.playPauseIcon, isPlayState(id) ? 'icon-pause' : 'icon-play');
      };

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(styles.tracklist, (0, _defineProperty3.default)({}, styles.playable, playable), className) },
        tracks.map(function (track, trackIndex) {
          return _react2.default.createElement(
            'div',
            {
              key: track.id,
              className: (0, _classnames2.default)(styles.trackItem, (0, _defineProperty3.default)({}, styles.active, currentTrack.id === track.id)),
              onClick: function onClick() {
                return playable && _this2.play(trackIndex);
              }
            },
            _react2.default.createElement(
              'div',
              { className: 'table-cell break-word' },
              trackIndex + 1,
              ' ',
              track.trackName
            ),
            _react2.default.createElement(
              'div',
              { className: 'table-cell width-perc-1' },
              currentTrack.id === track.id ? humanizedPosition : track.durationTime
            ),
            playable && _react2.default.createElement(
              'div',
              { className: styles.addPlaylistCell },
              _react2.default.createElement(_MyPlaylistsAddIcon2.default, { track: track, iconClass: styles.addPlaylistIcon })
            ),
            playable && _react2.default.createElement(
              'div',
              { className: 'table-cell width-perc-1' },
              _react2.default.createElement('i', { className: getPlayPauseClass(track.id) })
            )
          );
        })
      );
    }
  }]);
  return QuickSendTracklist;
}(_react.Component), _class2.propTypes = {
  album: _propTypes2.default.object,
  className: _propTypes2.default.string,
  currentTrackIndex: _propTypes2.default.number,
  humanizedPosition: _propTypes2.default.string,
  playable: _propTypes2.default.bool,
  playAlbum: _propTypes2.default.func,
  playerStatus: _propTypes2.default.string,
  playerTracks: _propTypes2.default.array,
  tracks: _propTypes2.default.array
}, _temp)) || _class);
exports.default = QuickSendTracklist;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/QuickSend/QuickSendTracklist.js
// module id = 836
// module chunks = 1